import { JVInput } from "../../shared/JVInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { EmptyProcess, IProcess } from "./Table";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { JVDropdown } from "../../shared/JVDropdown";
import { ICompanyMastDropdown, IRolesDropdown } from "../../models/IDropdown";

const schema = yup.object({
    company_ID: yup.number().min(1, "Company is required*").required("Company is required*"),
    department_ID: yup.number().min(1, "Department is required*").required("Department is required*"),
    subDepartment_ID: yup.number().min(1, "Sub Department is required*").required("Sub Department is required*"),
    resPerson: yup.string().nullable(),
    altResPerson: yup.string().nullable(),
    action: yup.string().nullable(),
    reaction: yup.string().nullable(),
});

interface IProps {
    singleData: IProcess,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: IProps) => {
    const [saveDis, setSaveDis] = useState(false);
    const [action, setAction] = useState("");
    const [reaction, setReaction] = useState("");
    const [roles, setRoles] = useState<Array<IRolesDropdown>>();
    const [subRoles, setSubRoles] = useState<Array<IRolesDropdown>>();
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IProcess>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const saveToDB = async (body: any) => {
        if ((body.reaction === "" && body.action === "") || (body.reaction === null && body.action === null)) {
            props.toast.current.show({ severity: 'error', detail: "Action and Reaction field is required", life: 3000 });
            setSaveDis(false);
        } else if (body.reaction === "" || body.reaction === null) {
            props.toast.current.show({ severity: 'error', detail: "Reaction field is required", life: 3000 });
            setSaveDis(false);
        } else if (body.action === "" || body.action === null) {
            props.toast.current.show({ severity: 'error', detail: "Action field is required", life: 3000 });
            setSaveDis(false);
        } else {
            const method = props.singleData.process_ID ? "PUT" : "POST";
            const message = props.singleData.process_ID ? "Updated Successfully" : "Added Successfully";
            const response = await Fetch("tbl_process", method, body, null, props.toast);
            if (response) {
                onHide();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
                setSaveDis(false);
            } else {
                setSaveDis(false);
            }
        }
    }

    const onSubmit = (data: IProcess) => {
        setSaveDis(true);
        data.action = action;
        data.reaction = reaction;
        saveToDB(data);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyProcess);
        setAction("");
        setReaction("");
        setSaveDis(false);
    }

    const loadRoles = async () => {
        const response = await Fetch("Dropdown/rolessub", "GET", null, null, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setRoles(_data);
        }
    }

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(data);
        }
    }

    const loadSubRoles = async () => {
        const response = await Fetch("Dropdown/getsubRoles", "GET", null, null, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setSubRoles(_data);
        }
    }
    useEffect(() => {
        reset(props.singleData);
        setAction(props.singleData.action || "");
        setReaction(props.singleData.reaction || "");
        loadRoles();
        loadSubRoles();
        loadCompanies();
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Process" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                {/* <JVInput column={3} required label="Company Name:" control={control} name="company_Name" error={errors.company_Name?.message} /> */}
                <JVDropdown column={3} required label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" error={errors.company_ID?.message} />

                <JVInput column={3} required label="Process Name:" control={control} name="process_Name" error={errors.process_Name?.message} />
                {/* <JVInput column={3} required label="Department:" control={control} name="department" error={errors.department?.message} /> */}
                <JVDropdown required column={3} label="Department:" control={control} name="department_ID" options={roles} optionLabel="role_Name" optionValue="role_ID" placeholder="Select Department" error={errors.department_ID?.message} />
                <JVDropdown required column={3} label="Sub Department:" control={control} name="subDepartment_ID" options={subRoles} optionLabel="role_Name" optionValue="role_ID" placeholder="Select Sub Department" error={errors.subDepartment_ID?.message} />
                {/* <JVInput column={3} label="Sub Department:" control={control} name="subDepartment" error={errors.subDepartment?.message} /> */}
                <JVInput column={3} label="Res. Person:" control={control} name="resPerson" error={errors.resPerson?.message} />
                <JVInput column={3} label="Alt Res. Person:" control={control} name="altResPerson" error={errors.altResPerson?.message} />

                <div className="flex m-auto" style={{ width: "98%" }}>
                    <div className="flex flex-column w-6">
                        <label htmlFor="req_JobDescription">Action:<span style={{ color: 'red' }}>*</span></label>
                        {/* <JVSunEditor name="Action*" value={action} handleChange={setAction} /> */}
                        <CKEditor editor={ClassicEditor} data={action} onChange={(event, editor) => { setAction(editor.getData()); }} />
                    </div>
                    <div className="flex flex-column w-6">
                        <label htmlFor="req_JobDescription">Reaction:<span style={{ color: 'red' }}>*</span></label>
                        {/* <JVSunEditor name="Reaction*" value={reaction} handleChange={setReaction} /> */}
                        <CKEditor editor={ClassicEditor} data={reaction} onChange={(event, editor) => { setReaction(editor.getData()); }} />
                    </div>
                </div>
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" disabled={saveDis}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}